import { render, staticRenderFns } from "./corpdetail.vue?vue&type=template&id=1f5b7de2&"
import script from "./corpdetail.vue?vue&type=script&lang=js&"
export * from "./corpdetail.vue?vue&type=script&lang=js&"
import style0 from "./corpdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports